import { BRAND } from "@/brand";
import Crown from "@/components/Crown";

const ITEMS = [
  BRAND.name,
  "SOUTHERN CALIFORNIA STREETWEAR",
  BRAND.short,
  "NO COMFORT — NO MERCY",
  "CROWNED IN CONCRETE",
  "WORLDWIDE EXCLUSIVE",
];

export default function Marquee() {
  const row = (
    <>
      {ITEMS.map((t, i) => (
        <span key={i} className="mx-10 flex items-center gap-10 shrink-0">
          <span className="text-sm sm:text-base tracking-[0.3em] text-zinc-500 uppercase whitespace-nowrap">{t}</span>
          <Crown className="h-4 w-6 text-zinc-700 shrink-0" />
        </span>
      ))}
    </>
  );

  return (
    <div data-testid="marquee-editorial-ribbon" className="relative overflow-hidden border-y border-zinc-800/70 bg-[#0C0C0E] py-5">
      <div className="marquee-track flex w-max">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}
